import React, { useEffect } from 'react';
import {
    message,
    Button,
    Icon,
    Modal,
    Form,
    Input,
    Radio,
    Card,
    Select,
    Table,
    Checkbox,
    Row,
    Col,
    Popconfirm,
} from 'antd';
import { services } from '@comall-backend-builder/core';

import './index.less';
import { errorHandle } from '../../services';
const { Search } = Input;
const { Option } = Select;

const api = services.api;

export interface LabelRuleAddViewProps {
    form: any;
}
const confirmProps = {
    title: '确定要删除吗？',
    okText: '确定',
    cancelText: '取消',
};
export interface IState {
    visible: boolean;
    black_remark: string;
    visibleClear: boolean;
    clearType: boolean;
    productModal: {
        visible: boolean;
        type: string;
    };
}

// 商品经营管理
const LabelRuleAddView = ({ form }: LabelRuleAddViewProps) => {
    const path = services.navigation.getPathname();
    const [isEdit, setIsEdit] = React.useState(!path.includes('detail'));

    const [categoryCodeOptions, setCategoryCodeOptions] = React.useState([]);
    const [attributeOptions, setAttributeOptions] = React.useState([]);
    const [visible, setVisible] = React.useState(false);
    const [tableData, setTableData] = React.useState([]);
    const [attributeData, setAttributeData] = React.useState([]);
    const [attributeSelectedData, setAttributeSelectedData] = React.useState([]);
    const columns = [
        {
            title: '属性编码',
            dataIndex: 'code',
            key: 'code',
            align: 'center' as const,
        },
        {
            title: '字典编码',
            dataIndex: 'sapCode',
            key: 'sapCode',
            align: 'center' as const,
        },
        {
            title: '属性名称',
            dataIndex: 'name',
            key: 'name',
            align: 'center' as const,
        },
        {
            title: '属性类型',
            dataIndex: 'type',
            key: 'type',
            render: (text: string) => {
                return text === 'OPTION' || text === 'key_value' ? '码表' : '文本';
            },
            align: 'center' as const,
        },
        {
            title: '操作',
            align: 'center' as const,
            render: (_, record) => [
                isEdit && (
                    <Popconfirm
                        {...confirmProps}
                        onConfirm={() =>
                            setTableData(tableData.filter((attr) => attr.code !== record.code))
                        }
                    >
                        <Button size="small" type="link">
                            删除
                        </Button>
                    </Popconfirm>
                ),
            ],
        },
    ];
    const handleCancel = () => {
        setAttributeData(attributeOptions);
        setVisible(false);
    };

    const getCategoryCodeOptions = () => {
        api.get({ attr_code: 'ZHPPL', page: 1, per_page: 9999 }, { apiPath: '/attributes/options' })
            .then((res: any) => {
                if (res && res.result) {
                    setCategoryCodeOptions(res.result);
                }
            })
            .catch(errorHandle);
    };
    const getAttributeOptions = () => {
        api.get({ page: 1, per_page: 9999 }, { apiPath: '/products/getAttrList' })
            .then((res: any) => {
                if (res && res.result) {
                    setAttributeOptions(res.result);
                    setAttributeData(res.result);
                }
            })
            .catch(errorHandle);
    };
    const onSave = () => {
        form.validateFields((err, values) => {
            if (!err) {
                const params = {
                    ...values,
                    attr_list: tableData.map((item) => ({ attribute_key_code: item.code })),
                    brandCode: 860,
                };
                if (path.includes('update')) {
                    api.post(
                        { ...params, tag_core_code: path.split('/').pop() },
                        { apiPath: '/searchTag/coreUpdate' }
                    )
                        .then((res: any) => {
                            if (res && res.resultCode === 200) {
                                message.success('保存成功');
                                window.history.back();
                            } else {
                                message.error(res.resultMsg);
                            }
                        })
                        .catch(errorHandle);
                } else {
                    api.post(params, { apiPath: '/searchTag/coreTagAdd' })
                        .then((res: any) => {
                            if (res && res.resultCode === 200) {
                                message.success('保存成功');
                                window.history.back();
                            } else {
                                message.error(res.resultMsg);
                            }
                        })
                        .catch(errorHandle);
                }
            }
        });
    };
    const initForm = () => {
        if (path.includes('update') || path.includes('detail')) {
            const id = path.split('/').pop();
            api.get(
                { tagCoreCode: id, page: 1, per_page: 1 },
                { apiPath: `/searchTag/coreQueryPage` }
            )
                .then((res: any) => {
                    if (res && res.result) {
                        const data = res.result[0];
                        form.setFieldsValue({
                            categoryCode: data.categoryCode,
                        });
                        setTableData(
                            data.attrList.map((item) => ({
                                code: item.attributeKeyCode,
                                name: item.attributeValueDesc,
                                sapCode: item.dictKeyCode,
                                type: item.attributeType,
                            })) || []
                        );
                    }
                })
                .catch(errorHandle);
        }
    };
    useEffect(() => {
        getCategoryCodeOptions();
        getAttributeOptions();
        initForm();
    }, []);
    const cardTitle = (
        <>
            <span>设置规则范围</span>
            <span style={{ fontSize: '12px', color: '#1890FF' }}>
                (系统将根据配置的关键属性,用属性值自动为所属品类下的商品生成相印的标签)
            </span>
        </>
    );
    const checkboxLabel = (data) => (
        <div style={{ display: 'inline-block' }}>
            <div style={{ display: 'inline-block', width: '100px' }}>{data.code}</div>
            <div style={{ display: 'inline-block' }}>{data.name}</div>
        </div>
    );
    return (
        <>
            <Card title="适用品类范围">
                <Form layout="inline">
                    <Form.Item label="商品品类">
                        {form.getFieldDecorator('categoryCode', {
                            rules: [
                                {
                                    required: true,
                                    message: '请选择商品品类',
                                },
                            ],
                        })(
                            <Select
                                placeholder="请选择"
                                allowClear
                                showSearch
                                disabled={!isEdit}
                                style={{ width: 250 }}
                                filterOption={(input, option) =>
                                    option.props.children.toString().indexOf(input) >= 0
                                }
                            >
                                {categoryCodeOptions.map((d) => (
                                    <Option key={d.optionCode} value={d.optionCode}>
                                        {d.optionName}
                                    </Option>
                                ))}
                            </Select>
                        )}
                    </Form.Item>
                </Form>
            </Card>
            <Card title={cardTitle} style={{ marginTop: 20 }}>
                <Table columns={isEdit ? columns : columns.slice(0, -1)} dataSource={tableData} />
                {isEdit ? (
                    <div
                        style={{
                            textAlign: 'center',
                            width: '100%',
                            padding: '5px 0px',
                            border: '1px solid #ccc',
                            marginTop: 20,
                            cursor: 'pointer',
                        }}
                        onClick={() => {
                            setAttributeSelectedData(tableData);
                            setVisible(true);
                        }}
                    >
                        <Icon type="plus-circle" />
                        添加商品属性
                    </div>
                ) : null}
                <Modal
                    visible={visible}
                    title="选择商品属性"
                    onCancel={handleCancel}
                    onOk={() => {
                        setTableData(attributeSelectedData);
                        handleCancel();
                    }}
                    okText={'确认'}
                    width={900}
                    destroyOnClose
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div
                            style={{
                                width: '50%',
                                borderRight: '1px solid #eee',
                                height: '400px',
                                padding: '10px',
                                overflowY: 'auto',
                            }}
                        >
                            <Search
                                placeholder="输入码表编号或码表名称"
                                onSearch={(value) =>
                                    setAttributeData(
                                        attributeOptions.filter(
                                            (item: any) =>
                                                item.name.includes(value) ||
                                                item.code.includes(value)
                                        )
                                    )
                                }
                                onBlur={(e) =>
                                    setAttributeData(
                                        attributeOptions.filter(
                                            (item: any) =>
                                                item.name.includes(e.target.value) ||
                                                item.code.includes(e.target.value)
                                        )
                                    )
                                }
                                style={{ width: '100%' }}
                            />
                            <div style={{ padding: '10px 0px' }}>
                                <Icon type="database" /> 商品主数据码表
                            </div>
                            <Checkbox.Group
                                style={{ width: '100%' }}
                                value={attributeSelectedData.map((item) => item.code)}
                                onChange={(checkedValues) => {
                                    const allChecked = attributeSelectedData.map(
                                        (item) => item.code
                                    );
                                    const notInSelect = allChecked.filter(
                                        (code) =>
                                            !attributeData.map((item) => item.code).includes(code)
                                    );
                                    const uniqueCodes = new Set([...notInSelect, ...checkedValues]);
                                    setAttributeSelectedData(
                                        Array.from(uniqueCodes).map((code) => {
                                            const existingItem = attributeSelectedData.find(
                                                (item) => item.code === code
                                            );
                                            if (existingItem) {
                                                return existingItem;
                                            } else {
                                                return attributeOptions.find(
                                                    (item) => item.code === code
                                                );
                                            }
                                        })
                                    );
                                    // const data = attributeSelectedData.filter((item: any) => !checkedValues.includes(item.id));
                                    // const selectedAttributes = attributeOptions.filter((item: any) => checkedValues.includes(item.id));
                                    // setAttributeSelectedData([...data,...selectedAttributes]);
                                }}
                            >
                                {attributeData.map((item: any) => (
                                    <Row>
                                        <Checkbox
                                            style={{ width: '100%' }}
                                            key={item.code}
                                            value={item.code}
                                        >
                                            {checkboxLabel(item)}
                                        </Checkbox>
                                    </Row>
                                ))}
                            </Checkbox.Group>
                        </div>
                        <div
                            style={{
                                width: '50%',
                                padding: '10px',
                                height: '400px',
                                overflowY: 'auto',
                            }}
                        >
                            <div
                                style={{
                                    padding: '10px 0px',
                                    display: 'flex',
                                    width: '100%',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}
                            >
                                <div>
                                    <Icon type="check-circle" /> 已选
                                    {`${attributeSelectedData.length}/${attributeOptions.length}`}
                                </div>

                                <Button
                                    type="link"
                                    onClick={() => {
                                        setAttributeSelectedData([]);
                                    }}
                                >
                                    清空
                                </Button>
                            </div>
                            {attributeSelectedData.map((item: any) => (
                                <div
                                    key={item.id}
                                    style={{
                                        padding: '0px 10px',
                                        border: '1px solid rgb(242, 241, 240)',
                                        lineHeight: '30px',
                                        background: 'rgb(242, 241, 240)',
                                        borderRadius: '20px',
                                        marginBottom: '5px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                    }}
                                >
                                    <span style={{ marginRight: '10px' }}>{item.name}</span>
                                    <Icon
                                        type="close"
                                        style={{ lineHeight: '30px', color: '#1890FF' }}
                                        onClick={() => {
                                            setAttributeSelectedData(
                                                attributeSelectedData.filter(
                                                    (attr) => attr.code !== item.code
                                                )
                                            );
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </Modal>
                {isEdit ? (
                    <div>
                        <Button type="primary" style={{ marginTop: 20 }} onClick={onSave}>
                            保存
                        </Button>
                        <Button
                            style={{ marginLeft: 10, marginTop: 20 }}
                            onClick={() => {
                                window.history.back();
                            }}
                        >
                            取消
                        </Button>
                    </div>
                ) : (
                    <Button
                        style={{ marginLeft: 10, marginTop: 20 }}
                        onClick={() => {
                            window.history.back();
                        }}
                    >
                        返回
                    </Button>
                )}
            </Card>
        </>
    );
};

export const labelRuleAddView = Form.create()(LabelRuleAddView);
